import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  Divider,
  Grid2,
  MenuItem,
  Select,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import ContainerLoading from "../components/ContainerLoading";
import { useCallback, useEffect, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  configurationUpdate,
  myPlan,
  taxValues,
  updateStore,
} from "../services/store";
import {
  formatCpfCnpj,
  formatDate,
  formatPaymentType,
  formatPercentage,
  formatPrice,
  formatRecurrence,
} from "../helpers/format";
import { getUser } from "../services/user";
import { useFormik } from "formik";
import { Input } from "../components/Input";
import { checkCep } from "../services/app";
import {
  IconArrowDown,
  IconBarbell,
  IconCloudUpload,
} from "@tabler/icons-react";
import { toast } from "react-toastify";
import { useDropzone } from "react-dropzone";
import StorePlansRegister from "../components/StorePlansRegister";
import PageHeader from "../components/PageHeader";

const MyGym = () => {
  const [value, setValue] = useState("1");
  const [logo, setLogo] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  const [notificationDays, setNotificationDays] = useState([
    {
      relative_days: -2,
      active: true,
    },
    {
      relative_days: 0,
      active: true,
    },
    {
      relative_days: 5,
      active: true,
    },
  ]);
  const notificationDaysValues = () => {
    let daysValues = [];

    for (let i = -2; i <= 10; i++) {
      daysValues.push(i);
    }
    return daysValues;
  };
  const daysValues = notificationDaysValues();

  const handleSelectChange = (index: number, novoValor: number) => {
    setNotificationDays((prev) => {
      const newArr = [...prev];
      newArr[index] = {
        ...newArr[index],
        relative_days: novoValor,
      };
      return newArr;
    });
  };

  const handleSelectChangeActiveValue = (index: number, novoValor: boolean) => {
    setNotificationDays((prev) => {
      const newArr = [...prev];
      newArr[index] = {
        ...newArr[index],
        active: novoValor,
      };
      return newArr;
    });
  };

  const notificationDaysFormated = (
    notificationDays: { relative_days: number; active: boolean }[]
  ) => {
    const notificationDaysFiltered = Array.from(
      new Set(
        notificationDays.filter((f) => f.active).map((day) => day.relative_days)
      )
    );

    return notificationDaysFiltered.join(",");
  };

  const handleChangeValue = (
    _event: React.SyntheticEvent,
    newValue: string
  ) => {
    setValue(newValue);
  };

  const onDrop = useCallback((acceptedFiles: File[]) => {
    const file = acceptedFiles[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => setLogo(e.target?.result as string);
      reader.readAsDataURL(file);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "image/*": [] },
  });

  const {
    data: dataUser,
    isLoading: isLoadingUser,
    isFetching: isFetchingUser,
    refetch: refetchUser,
  } = useQuery({
    queryKey: ["getUser"],
    queryFn: getUser,
    initialData: { store: {}, user: {} },
  });

  const {
    data,
    isLoading,
    isFetching,
    refetch: refetchPlan,
  }: {
    data: {
      id: string;
      name: string;
      paymentType: string;
      value: number;
      cep: string;
      description: string;
      recurrence: string;
      startDate: string;
      endDate: string;
      createdAt: string | Date;
      status: boolean;
    };
    isLoading: boolean;
    isFetching: boolean;
    refetch: () => void;
  } = useQuery({
    queryKey: ["myPlan"],
    queryFn: myPlan,
    initialData: {},
  });

  const {
    data: dataCep,
    isLoading: isLoadingCep,
    isFetching: isFetchingCep,
    refetch,
  } = useQuery({
    queryFn: async () => await checkCep(values.cep),
    queryKey: ["getCep"],
    enabled: false,
  });

  const {
    data: tax,
    isLoading: isLoadingTax,
    isFetching: isFetchingTax,
  } = useQuery({
    queryFn: async () => await taxValues(),
    queryKey: ["taxValues"],
  });

  const taxaCredito = tax?.taxCreditCard * 100;
  const taxCreditCardTwoToSix = tax?.taxCreditCardTwoToSix * 100;

  const { mutate, isPending } = useMutation({
    mutationFn: updateStore,
    onSuccess: () => {
      refetchUser();
      toast.success("Dados da academia atualizado");
    },

    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  const { mutate: mutateConfiguration, isPending: isPendingConfiguration } =
    useMutation({
      mutationFn: configurationUpdate,
      onSuccess: () => {
        refetchUser();
        toast.success("Dados da academia atualizado");
      },

      onError: (e: { response: { data: { message: string } } }) => {
        toast.error(String(e?.response?.data?.message) || "Erro!");
      },
    });

  const { values, handleChange, setFieldValue, handleSubmit } = useFormik({
    initialValues: {
      id: "",
      name: "",
      email: "",
      document: "",
      logo: "",
      cep: "",
      street: "",
      number: "",
      complement: "",
      neighborhood: "",
      city: "",
      state: "",
      autoNotificationWpp: 0,
      gympassStatus: 0,
      gympassCheckinAuto: 0,
      blockCheckInStudentOverdue: 0,
      gympassId: "",
    },
    onSubmit: (values) => {
      if (!values.name) {
        toast.info("Preencha o nome da academia");
        return;
      }
      if (!values.email) {
        toast.info("Preencha o email da academia");
        return;
      }
      if (!values.document) {
        toast.info("Preencha o CPF/CNPJ da academia");
        return;
      }
      if (!values.cep) {
        toast.info("Preencha o CEP da academia");
        return;
      }
      if (!values.street) {
        toast.info("Preencha o endereço da academia");
        return;
      }
      if (!values.number) {
        toast.info("Preencha o número da academia");
        return;
      }
      if (!values.neighborhood) {
        toast.info("Preencha o bairro da academia");
        return;
      }
      if (!values.city) {
        toast.info("Preencha a cidade da academia");
        return;
      }
      if (!values.state) {
        toast.info("Preencha o estado da academia");
        return;
      }

      mutate({ ...values, logo: logo });
    },
  });

  useEffect(() => {
    if (dataUser) {
      setFieldValue("id", dataUser?.store?.id);
      setFieldValue("name", dataUser?.store?.name);
      setFieldValue("email", dataUser?.store?.email);
      setFieldValue("document", dataUser?.store?.document);

      setFieldValue("neighborhood", dataUser?.store?.address?.neighborhood);
      setFieldValue("number", dataUser?.store?.address?.number);
      setFieldValue("state", dataUser?.store?.address?.state);
      setFieldValue("street", dataUser?.store?.address?.street);
      setFieldValue("cep", dataUser?.store?.address?.cep);
      setFieldValue("city", dataUser?.store?.address?.city);
      setFieldValue("complement", dataUser?.store?.address?.complement);

      setFieldValue(
        "autoNotificationWpp",
        dataUser?.store?.autoNotificationWpp ? 1 : 0
      );

      setFieldValue("gympassStatus", dataUser?.store?.gympassStatus ? 1 : 0);
      setFieldValue(
        "gympassCheckinAuto",
        dataUser?.store?.gympassCheckinAuto ? 1 : 0
      );
      setFieldValue(
        "blockCheckInStudentOverdue",
        dataUser?.store?.blockCheckInStudentOverdue ? 1 : 0
      );

      setFieldValue("gympassId", dataUser?.store?.gympassId);

      if (dataUser?.store?.notificationDays) {
        const notificationDaysValues = dataUser?.store?.notificationDays
          .split(",")
          .map((s: string) => Number(s.trim()));

        const formatted = notificationDaysValues?.map((day: number) => {
          return {
            relative_days: day,
            active: true,
          };
        });

        while (formatted.length < 3) {
          formatted.push({
            relative_days: 0,
            active: false,
          });
        }

        setNotificationDays(formatted);
      }
    }
  }, [dataUser]);

  useEffect(() => {
    if (dataUser) {
      if (dataUser?.store?.logo) {
        setLogo(dataUser?.store?.logo);
      }
    }
  }, [dataUser]);

  useEffect(() => {
    if (dataCep) {
      setFieldValue("neighborhood", dataCep?.neighborhood);
      setFieldValue("state", dataCep?.state);
      setFieldValue("street", dataCep?.address);
      setFieldValue("city", dataCep?.city);
    }
  }, [dataCep]);

  const loading =
    isLoading ||
    isFetching ||
    isLoadingUser ||
    isFetchingUser ||
    isLoadingCep ||
    isFetchingCep ||
    isPending ||
    isLoadingTax ||
    isFetchingTax ||
    isPendingConfiguration;
  return (
    <ContainerLoading loading={loading}>
      <Grid2 container padding={2}>
        <PageHeader
          title="Minha academia"
          subtitle="Informações gerais da academia."
        />
        <Grid2 size={12}>
          <Tabs
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              marginBottom: 2,
            }}
            onChange={handleChangeValue}
            value={value}
            textColor="inherit"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Dados da academia" value="1" />
            <Tab label="Configurações" value="2" />

            <Tab label="Plano da academia" value="3" />
            <Tab label="Taxas de recebimento" value="4" />
          </Tabs>
        </Grid2>
        {value === "1" && (
          <Grid2 size={12}>
            <Grid2 container spacing={2}>
              <Grid2 size={12}>
                <Typography
                  variant="body1"
                  fontWeight={600}
                  color="secondary.contrastText"
                >
                  LOGO
                </Typography>

                {!logo ? (
                  <Box
                    sx={{
                      maxWidth: 300,
                      textAlign: "center",
                      mt: 1,
                    }}
                  >
                    {/* Área de Drop */}
                    <Box
                      {...getRootProps()}
                      sx={{
                        border: "2px dashed",
                        borderColor: "secondary.contrastText",
                        borderRadius: 2,
                        padding: 4,
                        backgroundColor: isDragActive
                          ? "primary.main"
                          : "secondary.main",
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "primary.dark" },
                      }}
                    >
                      <input {...getInputProps()} />
                      <IconCloudUpload size={24} />
                      <Typography>
                        {isDragActive
                          ? "Solte o arquivo aqui..."
                          : "Arraste ou clique para selecionar uma imagem"}
                      </Typography>
                    </Box>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      marginTop: 1,
                      maxWidth: 150,
                      height: 150,
                      justifyContent: "center",
                    }}
                  >
                    <img
                      style={{ width: 145, height: 120, borderRadius: "10px" }}
                      src={logo}
                      alt="logo"
                    />
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      sx={{ backgroundColor: "red" }}
                      onClick={() => setLogo("")}
                    >
                      Deletar logo
                    </Button>
                  </Box>
                )}
              </Grid2>
              <Grid2 size={{ xs: 12, md: 4 }}>
                <Input
                  id="name"
                  name="name"
                  label="Nome"
                  type="text"
                  fullWidth
                  size="small"
                  value={values.name}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, md: 4 }}>
                <Input
                  id="document"
                  name="document"
                  label="CPF/CNPJ"
                  type="text"
                  fullWidth
                  size="small"
                  value={formatCpfCnpj(values.document)}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, md: 4 }}>
                <Input
                  id="email"
                  name="email"
                  label="E-mail"
                  type="text"
                  fullWidth
                  size="small"
                  value={values.email}
                  onChange={handleChange}
                />
              </Grid2>

              <Grid2 size={12}>
                <Typography
                  variant="body1"
                  fontWeight={600}
                  color="secondary.contrastText"
                >
                  ENDEREÇO
                </Typography>
              </Grid2>

              <Grid2 size={12}>
                <Input
                  id="cep"
                  name="cep"
                  label="CEP"
                  type="text"
                  fullWidth
                  size="small"
                  value={values.cep}
                  onChange={handleChange}
                  onBlur={() => {
                    if (values.cep) {
                      refetch();
                    }
                  }}
                />
              </Grid2>
              <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={2}
                width="100%"
              >
                <Grid2 flex={5}>
                  <Input
                    id="street"
                    name="street"
                    label="Endereço"
                    type="text"
                    fullWidth
                    size="small"
                    value={values.street}
                    onChange={handleChange}
                  />
                </Grid2>
                <Grid2 flex={4}>
                  <Input
                    id="neighborhood"
                    name="neighborhood"
                    label="Bairro"
                    type="text"
                    fullWidth
                    size="small"
                    value={values.neighborhood}
                    onChange={handleChange}
                  />
                </Grid2>
                <Grid2 flex={3}>
                  <Input
                    id="number"
                    name="number"
                    label="Número"
                    type="text"
                    fullWidth
                    size="small"
                    value={values.number}
                    onChange={handleChange}
                  />
                </Grid2>
              </Stack>

              <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={2}
                width="100%"
              >
                <Grid2 flex={5}>
                  <Input
                    id="city"
                    name="city"
                    label="Cidade"
                    type="text"
                    fullWidth
                    size="small"
                    value={values.city}
                    onChange={handleChange}
                  />
                </Grid2>
                <Grid2 flex={2}>
                  <Input
                    id="state"
                    name="state"
                    label="Estado"
                    type="text"
                    fullWidth
                    size="small"
                    value={values.state}
                    onChange={handleChange}
                  />
                </Grid2>
                <Grid2 flex={5}>
                  <Input
                    id="complement"
                    name="complement"
                    label="Complemento"
                    type="text"
                    fullWidth
                    size="small"
                    value={values.complement}
                    onChange={handleChange}
                  />
                </Grid2>
              </Stack>
              {/* <Grid2 size={6}>
                <Typography sx={{ fontWeight: 700, fontSize: 12, mb: 1 }}>
                  Logo da academia
                </Typography>
                <Avatar
                  alt="gym_logo"
                  src={logo}
                  sx={{
                    width: 60,
                    height: 60,
                  }}
                />
              </Grid2> */}

              <Grid2 size={12}>
                <Stack
                  sx={{
                    flexDirection: "row",
                    alignItems: "flex-end",
                    width: "100%",
                    justifyContent: "flex-end",
                    height: "100%",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{ gap: 0.5 }}
                    onClick={() => handleSubmit()}
                  >
                    <IconBarbell size={18} />
                    <Typography variant="body2">Atualizar dados</Typography>
                  </Button>
                </Stack>
              </Grid2>
            </Grid2>
          </Grid2>
        )}{" "}
        {value === "2" && (
          <Grid2 size={12}>
            <Grid2 container spacing={2}>
              <Grid2 size={12}>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<IconArrowDown />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Typography
                      variant="body1"
                      fontWeight={600}
                      color="secondary.contrastText"
                    >
                      CONFIGURAÇÕES DE CHECK-IN
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid2 container spacing={2}>
                      <Grid2 size={6}>
                        <Typography
                          sx={{ fontWeight: 700 }}
                          fontSize={{ xs: "10px", sm: "14px" }}
                        >
                          Bloquear check-in de usuários inadimplentes
                        </Typography>
                        <Select
                          fullWidth
                          sx={{ mt: 1 }}
                          id="blockCheckInStudentOverdue"
                          name="blockCheckInStudentOverdue"
                          value={values.blockCheckInStudentOverdue}
                          onChange={(e) => {
                            setFieldValue(
                              "blockCheckInStudentOverdue",
                              e.target.value
                            );
                          }}
                        >
                          <MenuItem value={1}>Ativo</MenuItem>
                          <MenuItem value={0}>Desativado</MenuItem>
                        </Select>
                      </Grid2>
                    </Grid2>
                  </AccordionDetails>
                </Accordion>
              </Grid2>
              <Grid2 size={12}>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<IconArrowDown />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                  >
                    <Typography
                      variant="body1"
                      fontWeight={600}
                      color="secondary.contrastText"
                    >
                      CONFIGURAÇÕES DAS NOTIFICAÇÕES
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid2 container spacing={2}>
                      <Grid2 size={12}>
                        <Typography sx={{ fontWeight: 700, fontSize: 14 }}>
                          Notificações do WhatsApp
                        </Typography>
                      </Grid2>
                      <Grid2 size={6}>
                        <Typography sx={{ fontWeight: 700, fontSize: 12 }}>
                          Notificação automática pelo WhatsApp
                        </Typography>
                        <Select
                          fullWidth
                          sx={{ mt: 1 }}
                          id="autoNotificationWpp"
                          name="autoNotificationWpp"
                          value={values.autoNotificationWpp}
                          onChange={(e) => {
                            setFieldValue(
                              "autoNotificationWpp",
                              e.target.value
                            );
                          }}
                        >
                          <MenuItem value={1}>Ativo</MenuItem>
                          <MenuItem value={0}>Desativado</MenuItem>
                        </Select>
                      </Grid2>
                      <Grid2 size={12}>
                        <Divider />
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography sx={{ fontWeight: 700, fontSize: 14 }}>
                          Enviar notificações relativo ao vencimento da cobrança
                          do cliente
                        </Typography>
                      </Grid2>
                      <Grid2 size={6}>
                        <Grid2 container spacing={2}>
                          {notificationDays.map((dayValue, index) => (
                            <Grid2 size={12} key={index}>
                              <Stack
                                direction={{ xs: "column", md: "row" }}
                                sx={{
                                  alignItems: "center",
                                  gap: { xs: 1.5, md: 3.5 },
                                }}
                              >
                                <Stack
                                  sx={{
                                    alignItems: "center",
                                  }}
                                  direction={{ xs: "row", md: "row" }}
                                >
                                  <Checkbox
                                    value={dayValue.active}
                                    checked={dayValue.active}
                                    onClick={() =>
                                      handleSelectChangeActiveValue(
                                        index,
                                        !dayValue.active
                                      )
                                    }
                                  />
                                  <Typography
                                    sx={{
                                      fontWeight: 700,
                                      fontSize: 16,
                                      flexShrink: 0,
                                    }}
                                  >
                                    {`${index + 1}° Notificação`}
                                  </Typography>
                                </Stack>
                                {dayValue.active && (
                                  <Select
                                    sx={{
                                      fontSize: { xs: "0.8rem", md: "1rem" },
                                      "& .MuiSelect-select": {
                                        paddingY: { xs: 1, md: 1.5 },
                                      },
                                      "&.MuiSelect-root": {
                                        marginTop: 0,
                                      },
                                    }}
                                    id={`notificationDays${index}`}
                                    name={`notificationDays${index}`}
                                    value={dayValue.relative_days}
                                    onChange={(e) =>
                                      handleSelectChange(
                                        index,
                                        Number(e.target.value)
                                      )
                                    }
                                  >
                                    {daysValues.map((day) =>
                                      day === 0 ? (
                                        <MenuItem key={day} value={day}>
                                          Notificar no dia
                                        </MenuItem>
                                      ) : (
                                        <MenuItem key={day} value={day}>
                                          {day < 0
                                            ? `Notificar ${Math.abs(
                                                day
                                              )} dia(s) antes`
                                            : `Notificar ${day} dia(s) depois`}
                                        </MenuItem>
                                      )
                                    )}
                                  </Select>
                                )}
                              </Stack>
                            </Grid2>
                          ))}
                        </Grid2>
                      </Grid2>
                    </Grid2>
                  </AccordionDetails>
                </Accordion>
              </Grid2>
              <Grid2 size={12}>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<IconArrowDown />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Typography
                      variant="body1"
                      fontWeight={600}
                      color="secondary.contrastText"
                    >
                      CONFIGURAÇÕES DO GYMPASS
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid2 container spacing={2}>
                      <Grid2 size={{ xs: 12, md: 4 }}>
                        <Typography sx={{ fontWeight: 700, fontSize: 12 }}>
                          Gympass
                        </Typography>
                        <Select
                          fullWidth
                          sx={{ mt: 1 }}
                          id="gympassStatus"
                          name="gympassStatus"
                          value={values.gympassStatus}
                          onChange={(e) => {
                            setFieldValue("gympassStatus", e.target.value);
                          }}
                        >
                          <MenuItem value={1}>Ativo</MenuItem>
                          <MenuItem value={0}>Desativado</MenuItem>
                        </Select>
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 4 }}>
                        <Input
                          id="gympassId"
                          name="gympassId"
                          label="ID da academia no Gympass ( Wellhub )"
                          type="text"
                          fullWidth
                          size="small"
                          disabled={!values.gympassStatus}
                          value={values.gympassId}
                          onChange={handleChange}
                        />
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 4 }}>
                        <Typography sx={{ fontWeight: 700, fontSize: 12 }}>
                          Check-in automático
                        </Typography>
                        <Select
                          fullWidth
                          sx={{ mt: 1 }}
                          id="gympassCheckinAuto"
                          name="gympassCheckinAuto"
                          disabled={!values.gympassStatus}
                          value={values.gympassCheckinAuto}
                          onChange={(e) => {
                            setFieldValue("gympassCheckinAuto", e.target.value);
                          }}
                        >
                          <MenuItem value={1}>Ativo</MenuItem>
                          <MenuItem value={0}>Desativado</MenuItem>
                        </Select>
                      </Grid2>
                    </Grid2>
                  </AccordionDetails>
                </Accordion>
              </Grid2>

              <Grid2 size={12}>
                <Stack
                  sx={{
                    flexDirection: "row",
                    alignItems: "flex-end",
                    width: "100%",
                    justifyContent: "flex-end",
                    height: "100%",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{ gap: 0.5 }}
                    onClick={() => {
                      mutateConfiguration({
                        gympassId: values.gympassId,
                        gympassStatus: values.gympassStatus,
                        autoNotificationWpp: values.autoNotificationWpp,
                        gympassCheckinAuto: values.gympassCheckinAuto,
                        blockCheckInStudentOverdue:
                          values.blockCheckInStudentOverdue,
                        notificationDays:
                          notificationDaysFormated(notificationDays),
                      });
                    }}
                  >
                    <IconBarbell size={18} />
                    <Typography variant="body2">
                      Atualizar configurações
                    </Typography>
                  </Button>
                </Stack>
              </Grid2>
            </Grid2>
          </Grid2>
        )}
        {value === "3" && (
          <Grid2 size={12}>
            <Stack sx={{ width: "100%" }} spacing={4}>
              {data ? (
                <Stack
                  spacing={2}
                  sx={{
                    padding: 2,
                    borderRadius: 2,
                    backgroundColor: "primary.main",
                    maxWidth: 600,
                  }}
                >
                  <Typography variant="h3" fontWeight={700} fontSize={18}>
                    {data?.name}
                  </Typography>
                  <Stack spacing={1}>
                    <Typography variant="body1" fontWeight={600} fontSize={12}>
                      {data?.description}
                    </Typography>
                    <Typography variant="body1" fontWeight={600} fontSize={12}>
                      {formatPaymentType(data?.paymentType)}
                    </Typography>
                  </Stack>
                  <Stack
                    spacing={1}
                    sx={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="body1" fontWeight={600} fontSize={18}>
                      {formatPrice(data?.value)}
                    </Typography>
                    <Typography variant="body1" fontWeight={600} fontSize={12}>
                      {formatRecurrence(data?.recurrence)}
                    </Typography>
                  </Stack>
                  <Stack
                    spacing={1}
                    sx={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Stack
                      direction={{ xs: "column", md: "row" }}
                      sx={{
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Typography
                        variant="body1"
                        fontWeight={600}
                        fontSize={{ xs: "12px", sm: "16px" }}
                      >
                        Inicio do plano:
                      </Typography>
                      <Typography
                        variant="body1"
                        fontSize={{ xs: "12px", sm: "16px" }}
                      >
                        {formatDate(data?.startDate)}
                      </Typography>
                    </Stack>
                    <Stack
                      direction={{ xs: "column", md: "row" }}
                      sx={{
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Typography
                        variant="body1"
                        fontWeight={600}
                        fontSize={{ xs: "12px", sm: "16px" }}
                      >
                        Fim do plano:
                      </Typography>
                      <Typography
                        variant="body1"
                        fontSize={{ xs: "12px", sm: "16px" }}
                      >
                        {formatDate(data?.endDate)}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              ) : (
                <Stack
                  spacing={2}
                  sx={{
                    padding: 2,
                    borderRadius: 2,
                    backgroundColor: "secondary.main",
                    maxWidth: 600,
                  }}
                >
                  <Typography variant="h3" fontWeight={700} fontSize={18}>
                    Você não possui plano cadastrado
                  </Typography>
                  <Typography variant="body1" fontWeight={600} fontSize={12}>
                    Você ainda não possui nenhum plano cadastrado. Não perca
                    tempo, clique no botão abaixo para se registrar em um dos
                    nossos planos.
                  </Typography>
                  <Button
                    variant="contained"
                    size="large"
                    onClick={() => setOpen(true)}
                  >
                    <Typography variant="body2">Selecionar plano</Typography>
                  </Button>
                </Stack>
              )}
            </Stack>
          </Grid2>
        )}
        {value === "4" && (
          <Grid2 size={12}>
            <Stack sx={{ width: "100%" }} spacing={4}>
              <Stack spacing={2}>
                <Typography
                  variant="h3"
                  fontWeight={600}
                  fontSize={16}
                  color="secondary.contrastText"
                >
                  Cartão de crédito
                </Typography>
                <Typography variant="body1" fontWeight={600} fontSize={14}>
                  - {formatPercentage(taxaCredito)} À vista
                </Typography>
                <Typography variant="body1" fontWeight={600} fontSize={14}>
                  - {formatPercentage(taxCreditCardTwoToSix)} 2 à 6 parcelas
                </Typography>
                <Typography variant="body1" fontWeight={600} fontSize={14}>
                  - Compensação D+32
                </Typography>
              </Stack>
              <Stack spacing={2}>
                <Typography
                  variant="h3"
                  fontWeight={600}
                  fontSize={16}
                  color="secondary.contrastText"
                >
                  Cobrança boleto ou pix ( pagos )
                </Typography>
                <Typography variant="body1" fontWeight={600} fontSize={14}>
                  - {formatPrice(tax?.taxPixBillet)}
                </Typography>
                <Typography variant="body1" fontWeight={600} fontSize={14}>
                  - {formatPrice(tax?.taxMarketplaceLessTen)} ( Pedido abaixo de
                  R$ 10,00 no marketplace )
                </Typography>
              </Stack>

              <Stack spacing={2}>
                <Typography
                  variant="h3"
                  fontWeight={600}
                  fontSize={16}
                  color="secondary.contrastText"
                >
                  Mensageria
                </Typography>
                <Typography variant="body1" fontWeight={600} fontSize={14}>
                  - Grátis - E-mail
                </Typography>{" "}
                <Typography variant="body1" fontWeight={600} fontSize={14}>
                  - Grátis - SMS
                </Typography>{" "}
                <Typography variant="body1" fontWeight={600} fontSize={14}>
                  - Grátis - Notificação push pelo app
                </Typography>{" "}
                <Typography variant="body1" fontWeight={600} fontSize={14}>
                  - {formatPrice(tax?.taxNotificationWpp)} - WhatsApp
                </Typography>
              </Stack>
            </Stack>
          </Grid2>
        )}
      </Grid2>
      <StorePlansRegister
        open={open}
        storeId={dataUser?.store?.id}
        onClose={() => setOpen(false)}
        refetch={() => refetchPlan()}
      />
    </ContainerLoading>
  );
};

export default MyGym;
